module.exports = __webpack_public_path__ + "img/helpOtdel.56865fb8.svg";